import React, {Component} from "react";
import {ff, form} from "@mc/mc-legacy";
import {Button, Label} from "reactstrap";
import {FormErrors, reduxForm} from "redux-form";

type FormData = {
    jmeno: string,
    prijmeni: string,
    datumNarozeni: string,
    email: string,
    oboustranne: boolean,
};

const validate = (data: FormData) => {
    const errors: FormErrors<FormData> = {};
    console.log("-> validate", data);
    if (!data.jmeno) {
        errors.jmeno = "Jméno je povinné";
    }
    if (!data.prijmeni) {
        errors.prijmeni = "Příjmení je povinné";
    }
    if (!data.datumNarozeni) {
        errors.datumNarozeni = "Datum je povinný";
    }

    if (!data.email) {
        errors.email = "Email je povinný";
    }

    return errors;
};

class FoInput extends Component<any> {

    constructor(props) {
        super(props);
    }

    render() {
        const {onClose, handleSubmit, submitting} = this.props;
        return (
            <div>
                <form.Form className={"form"} onSubmit={handleSubmit}>
                    <form.FormBody className={"mb-3"}>
                        <Label for={"jmeno"}>Jméno</Label>
                        <ff.String
                            autoComplete={"off"}
                            label={false}
                            name={"jmeno"}
                            disabled={submitting}
                            required />
                        <Label for={"prijmeni"}>Příjmení</Label>
                        <ff.String
                            autoComplete={"off"}
                            label={false}
                            name={"prijmeni"}
                            disabled={submitting}
                            required />

                        <Label for={"datumNarozeni"}>Datum narození</Label>
                        <ff.SimpleDate label={false} name={"datumNarozeni"}/>

                        <Label for={"email"}>Email</Label>
                        <ff.String
                            autoComplete={"off"}
                            label={false}
                            name={"email"}
                            disabled={submitting}
                            required />
                        <Label for={"oboustranne"} className={"mb-0 d-flex"}>Oboustranný přístup</Label>
                        <ff.Checkbox name='oboustranne' label="" style={{marginTop: -10 }}/>

                    </form.FormBody>
                    <form.FormActions disabled={submitting} submitButton={false}>
                        <Button
                            className={"ml-2"}
                            color={"primary"}
                            disabled={submitting}
                        >
                            Vytvořit
                        </Button>
                    </form.FormActions>
                </form.Form>
            </div>
        );
    }
}
const FoInputForm = reduxForm<FormData, any>({
    form: "foInput",
    validate: validate,
})(FoInput);
export default FoInputForm;
